import * as types from './actionTypes';
import {logout} from '../helper/helper';
import companyInfoApi from '../api/companyInfoApi';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2';
import { loadingRes } from './loadingActions';

export function companyInfoRes(data) {
  return {
    type: types.FETCH_COMPANY_INFO_RES,
    data
  };
}

export function fetchCompanyInfo(data) {
  const TOKEN = getItem('auth_token');

  if(TOKEN){
    return function(dispatch) {
      dispatch(loadingRes(true));
      companyInfoApi.companyInfoData(data).then(data => {
        dispatch(companyInfoRes(data));
        dispatch(companyInfoRes(null));
        dispatch(loadingRes(false));
        if(data.error){
          dispatch(companyInfoRes(data));
          dispatch(companyInfoRes(null));
          Swal.fire({
            title: data.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          })
        } 
      }).catch(error => {
        dispatch(loadingRes(false));
        return error
      });
    };
  }else{
    logout()
  }
}